<template>
  <MGuidedCheckoutStep
    :step-number="stepNumber"
    title="Lieferung oder Abholung?"
    description="Bestimme, ob wir deine Auswahl liefern oder zur Abholung im Markt bereitstellen sollen."
  >
    <div
      id="product-guided-checkout-fulfillment"
      class="m-gc-step-fulfillment__options"
    >
      <div
        class="m-gc-step-fulfillment__option"
        :class="{ 'm-gc-step-fulfillment__option--active': value === 'delivery' }"
        @click="$emit('input', 'delivery')"
      >
        <strong>Online-Bestellung & Lieferung</strong>

        <OnlineAvailability
          class="m-gc-step-fulfillment__availability"
          :product="product"
          :qty="productStock.max"
          :threshold-qty="productStock.thresholdQuantity"
          :show-delivery-time="true"
        />
      </div>

      <div
        class="m-gc-step-fulfillment__option"
        :class="{ 'm-gc-step-fulfillment__option--active': value === 'pickup' }"
        @click="$emit('input', 'pickup')"
      >
        <strong>Abholung im Markt</strong>

        <StoreAvailability
          class="m-gc-step-fulfillment__availability"
          :product="product"
          :qty="productStock.max"
          :qty-pickup="productStock.maxPickup"
          :threshold-qty="productStock.thresholdQuantity"
          :show-modal-button="true"
          :show-not-selected="true"
        />
      </div>
    </div>
  </MGuidedCheckoutStep>
</template>

<script>
import MGuidedCheckoutStep from 'theme/components/molecules/guided-checkout/m-guided-checkout-step'
import StoreAvailability from 'src/modules/vsf-inventory-sources/components/StoreAvailability'
import OnlineAvailability from 'src/modules/vsf-inventory-sources/components/OnlineAvailability'

export default {
  name: 'MGcStepFulfillment',
  components: {
    MGuidedCheckoutStep,
    StoreAvailability,
    OnlineAvailability
  },
  props: {
    stepNumber: {
      type: [Number, String],
      default: 6
    },
    value: {
      type: String,
      default: 'delivery'
    },
    product: {
      type: Object,
      required: true
    },
    productStock: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value (mode) {
      this.syncPickupMode(mode)
    }
  },
  async mounted () {
    await this.$store.dispatch('inventorySources/init', {})

    const isPickup = this.$store.state.inventorySources.isPickup
    if (isPickup && this.value !== 'pickup') {
      this.$emit('input', 'pickup')
      return
    }

    await this.syncPickupMode(this.value)
  },
  methods: {
    async syncPickupMode (mode) {
      await this.$store.dispatch('inventorySources/init', {})
      await this.$store.dispatch('inventorySources/setIsPickup', mode === 'pickup')
    }
  }
}
</script>

<style lang="scss" scoped>
.m-gc-step-fulfillment {
  &__options {
    display: grid;
    gap: 1rem;

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  &__option {
    display: block;
    width: 100%;
    height: auto;
    min-height: 0;
    padding: 1rem;
    border: 1px solid var(--c-light);
    border-radius: 4px;
    background: var(--c-white);
    text-align: left;
    cursor: pointer;
    white-space: normal;
    overflow: hidden;
    transition: var(--gc-transition);

    strong {
      display: block;
      margin-bottom: 0.35rem;
      line-height: 1.3;
      white-space: normal;
    }

    &--active {
      border-color: var(--c-primary);
      box-shadow: 0 0 0 1px var(--c-primary);
    }
  }

  &__availability {
    margin: 0.35rem 0 0;
  }
}
</style>
